import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { apolloService } from '../../common/services'

import { USER_ALLOCATION_COUNTS_QUERY } from '../graphql/queries'
import { FETCH_USER_ALLOCATION_COUNTS } from '../redux/action-types'

const useUserAllocationCountsLazyQuery = () => {
  const dispatch = useDispatch()

  const {
    userAllocationCounts: data,
    isUserAllocationCountsLoading: isLoading,
    userAllocationCountsError: error,
  } = useSelector(store => store.priorityTasks.priorityTask)

  const fetch = useCallback(
    id =>
      apolloService.query({
        query: USER_ALLOCATION_COUNTS_QUERY,
        variables: {
          id,
        },
        dispatch,
        action: FETCH_USER_ALLOCATION_COUNTS,
      }),
    [dispatch],
  )

  return [fetch, { isLoading, error, data }]
}

export default useUserAllocationCountsLazyQuery
